import { create } from 'zustand';

type InitialData = {
  name?: string;
  email?: string;
  mobileNumber?: string;
  sessionId?: string;
};

type FiltersStore = {
  data: InitialData;
  isUserLoggedIn: boolean;
  customerId: string;
  fxCustomerId: string;
  setData: (data: Partial<InitialData>) => void;
  setUserLoggedIn: (isLoggedIn: boolean) => void;
  setCustomerId: (customerID: string) => void;
  setFxCustomerId: (fxCustomerID: string) => void;
  reset: () => void;
  clear: () => void;
};

const initialData = {
  name: '',
  email: '',
  mobileNumber: '',
  sessionId: '',
};

export const useReferAndEarnStore = create<FiltersStore>((set) => ({
  data: initialData,
  isUserLoggedIn: false,
  customerId: '',
  fxCustomerId: '',
  setData: (newData: Partial<InitialData>) =>
    set((state) => ({
      data: {
        ...state,
        ...newData,
      },
    })),
  setUserLoggedIn: (isLoggedIn: boolean) =>
    set((state) => ({
      ...state,
      isUserLoggedIn: isLoggedIn,
    })),
  setCustomerId: (customerID: string) =>
    set((state) => ({
      ...state,
      customerId: customerID,
    })),
  setFxCustomerId: (fxCustomerID: string) =>
    set((state) => ({
      ...state,
      fxCustomerId: fxCustomerID,
    })),
  reset: () =>
    set((state) => ({
      data: {
        ...initialData,
        mobileNumber: state.data.mobileNumber,
      },
      isUserLoggedIn: state.isUserLoggedIn,
      customer_id: '',
      fxCustomer_id: '',
    })),
  clear: () => {
    set(() => ({
      data: {
        ...initialData,
      },
      isUserLoggedIn: false,
      customer_id: '',
      fxCustomer_id: '',
    }));
  },
}));
